import { createStyles, makeStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  label: {
    display: 'flex',
    alignItems: 'center',
    color: palette.text.primary,
  },
  icon: {
    fontSize: 16,
    marginRight: 12,
  },
}));

export default useStyles;
